'use client';
/**
 * @file     LogoSvg.tsx
 * @readme   ./README.md
 * @purpose  Inline SVG rendering the Relta brand logo mark, colour-adapted for light/dark modes.
 */

import { useAppTheme } from '@/core/theme/useAppTheme';

const LogoSvg = ({ height = 82, mb, mt }: { height?: number; mb?: string; mt?: string }) => {
  const { mode, theme } = useAppTheme();
  const fillColor =
    mode === 'light'
      ? theme.semanticColors.textPrimary
      : theme.semanticColors.textSecondary;
  const strokeColor =
    mode === 'light'
      ? theme.semanticColors.textPrimary
      : theme.semanticColors.borderStrong;

  const strokeStyle = {
    fill: fillColor,
    stroke: strokeColor,
    strokeMiterlimit: 10,
    strokeWidth: '0.75px',
  };

  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1093.33 1087.05"
      style={{ height, width: 'auto', marginBlock: `${mt ?? '0'} ${mb ?? '0'}` }}
    >
      <path
        d="M108.58,539.88l-3.35,3.65c1.07-1.25,2.19-2.47,3.35-3.65Z"
        style={strokeStyle}
      />
      <g>
        <path
          d="M103.4,542.7l-3.49,3.93c1.11-1.35,2.28-2.66,3.49-3.93Z"
          style={strokeStyle}
        />
        <path
          d="M271.69,329.81l-112.22,141.96L2.14,652.21c-1.25,1.43-1.83,3.26-1.75,5.04-.04.52,0,1.06.1,1.58l5.74,30.42c.95,5.04,7.05,6.86,10.45,3.11l50.55-52.88c1.09-1.2,3.02-.4,3.02,1.22v.05c0,113.97,73.07,154.84,173.68,154.84h12.12c11.01,0,17.09,13.19,10.18,22.04l-193.13,247.02c-6.91,8.85-.83,22.03,10.18,22.03h226.64c5.53,0,10-4.63,10-10.34v-17.03c0-5.71-4.48-10.34-10-10.34h-156.84c-5.08,0-7.94-6.05-4.81-10.21l196.58-260.98c6.7-8.88.58-21.83-10.3-21.83h-65.46c-112.59,0-156.93-26.01-156.93-116.44,0-71.85,47.92-105.3,137.76-105.3h112.35c6.76,0,12.22,5.66,12.22,12.64v525.14c0,8.11,6.35,14.68,14.19,14.68h17.05c7.23,0,13.09-6.06,13.09-13.54V508.11c0-7.49-5.86-13.54-13.09-13.54h-152.21c-9.14,0-17.94.27-26.38.81-11.03.71-17.15-12.95-9.6-21.27L530.92,76.27c5.45-6,26.73-6,32.19,0l313.38,397.85c7.56,8.32,1.42,21.98-9.59,21.27-8.46-.54-17.25-.81-26.4-.81h-152.85c-6.86,0-12.44,5.75-12.44,12.86v566.6c0,.15,0,.29.01.44.33,6.57,5.43,11.85,11.79,12.19h22.48c5.55.01,10.04-4.64,10.04-10.38v-529.43c0-6.97,5.48-12.64,12.22-12.64h112.35c89.84,0,137.76,33.45,137.76,105.3,0,90.42-44.32,116.44-156.92,116.44h-66.79c-10.35,0-16.17,12.33-9.8,20.76l197.39,262.05c3.12,4.15.27,10.21-4.81,10.21h-156.95c-5.55,0-10.04,4.64-10.04,10.38v16.95c0,5.73,4.49,10.38,10.04,10.38h228.13c10.46,0,16.24-12.54,9.66-20.95l-194.83-249.2c-6.57-8.41-.8-20.95,9.66-20.95h13.48c100.63,0,173.7-40.87,173.7-154.84v-.05c0-1.62,1.93-2.42,3.02-1.22l49.85,52.17c3.41,3.76,9.49,1.93,10.45-3.11l5.74-30.42c.18-.95.16-1.9-.07-2.81-.18-1.37-.75-2.69-1.7-3.81l-154.25-176.89L585.2,29.85l-21.97-24.84c-5.48-6.18-26.96-6.18-32.44,0l-21.97,24.84-187.41,237.08-49.72,62.89Z"
          style={strokeStyle}
        />
        <path
          d="M687.02,1086.66c.13.01.27.01.42.01"
          style={strokeStyle}
        />
      </g>
    </svg>
  );
};

export default LogoSvg;
